<template>
  <div class="range">
    <div class="inputgroup price">
      <label class="f8 label" for="price">{{ $t('Select the number of players') }}</label>
      <div class="range">
        <UIRange
          class="price-range"
          :min="min"
          :max="max"
          :value="booking.numPlayers"
          @input="setNumberOfPlayers"
          step="1"
        />
        <div class="playeramount f5">{{ booking.numPlayers }} {{ $tc('player', booking.numPlayers )}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import UIRange from '@/core/shared/components/ui/UIRange';

@Component({
  components: {
    UIRange,
  },
  props: {
    booking: {
      type: Object,
      required: true,
    },
    location: {
      type: Object,
      required: true,
    },
  },
})
export default class Players extends Vue {
  get min () {
    if (this.booking.bookingStationTimes.length < 1) return 1;
    return this.booking.bookingStationTimes.length;
  }

  get max () {
    return 50;
  }

  created () {
    if (this.booking.numPlayers < this.booking.bookingStationTimes.length) {
      this.$emit('edit:booking', 'numPlayers', this.booking.bookingStationTimes.length);
    }
  }

  setNumberOfPlayers (e) {
    this.$emit('edit:booking', 'numPlayers', parseInt(e.target.value));
  }
}
</script>

<style scoped lang="postcss">
@import "core/shared/styles";

.label {
  display: block;
  margin-bottom: var(--spacingXS);
}

.range {
  display: grid;
  grid-gap: var(--spacingSm);
  grid-template-columns: 1fr auto;
}

</style>
